import * as React from 'react'
import Helmet from 'react-helmet'
import { Carousel } from 'react-bootstrap';

import * as s1 from "./../assets/home-slideshow/01.jpg"
import * as s2 from "./../assets/home-slideshow/02.jpg"
import * as s3 from "./../assets/home-slideshow/03.jpg"
import * as s4 from "./../assets/home-slideshow/04.jpg"
import * as s5 from "./../assets/home-slideshow/05.jpg"
import * as s6 from "./../assets/home-slideshow/06.jpg"

import * as l1 from "./../assets/logos/ASLA.png"
import * as l2 from "./../assets/logos/CLCA.png"
import * as l3 from "./../assets/logos/USGBC.png"
import * as l4 from "./../assets/logos/CLARB.png"
import * as l5 from "./../assets/logos/junipertree.png"

import './index.css'

// Please note that you can use https://github.com/dotansimha/graphql-code-generator
// to generate all types from graphQL schema
interface IndexPageProps {
  data: {
    site: {
      siteMetadata: {
        title: string
      }
    }
  }
}

export default class extends React.Component<IndexPageProps, {}> {
  constructor(props: IndexPageProps, context: any) {
    super(props, context)
  }
  public render() {
    return (
      <div>
        <Helmet
            bodyAttributes={{
                class: 'index-body'
            }}
        />
        <div style={{
            height: "auto",
            padding: "1px 25px 15px",
          }}>

          <Carousel id="carousel">
            <Carousel.Item>
              <img width={1000} height={500} alt="First" src={s1} style={{margin: 0}}/>
              <Carousel.Caption>
                <p id="caption">LAND DEVELOPMENT SERVICES</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1000} height={500} alt="Second" src={s2} style={{margin: 0}}/>
              <Carousel.Caption>
                <p id="caption">LANDSCAPE ARCHITECTURE</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1000} height={500} alt="Third" src={s3} style={{margin: 0}}/>
              <Carousel.Caption>
                <p id="caption">PLANNING</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1000} height={500} alt="Fourth" src={s4} style={{margin: 0}}/>
              <Carousel.Caption>
                <p id="caption">DESIGN BUILD</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1000} height={500} alt="Fifth" src={s5} style={{margin: 0}}/>
              <Carousel.Caption>
                <p id="caption">CONSTRUCTION</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1000} height={500} alt="Sixth" src={s6} style={{margin: 0}}/>
              <Carousel.Caption>
                <p id="caption">POOL & SPA</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>

          <h4 className="index-header">
            ONE STOP SERVICE FOR ALL YOUR DESIGN-BUILD NEEDS
          </h4>
          <p className="index-para">
            With over 25 years of professional experience working in various design-build projects, our team knows the answer to successful projects can be found in the scientific and practical approach we take to exploring and identifying your needs. Our services include:
          </p>
          <ul className="index-list">
            <li>Planning and Landscape Architecture</li>
            <li>Landscape and General Construction</li>
            <li>Land Development</li>
            <li>Pool and Spa</li>
          </ul>

          <h4 className="index-header">
            PROFESSIONAL MEMBERSHIP
          </h4>   

          <div className="logos">
            <a href="https://www.asla.org/" target="_blank">
              <img width={185} height={76} alt="ASLA" src={l1} style={{marginRight: "12px"}}/>
            </a>
            <a href="http://www.clca.org/" target="_blank">
              <img width={181} height={76} alt="CLCA" src={l2} style={{marginRight: "12px"}}/>
            </a>
            <a href="http://www.usgbc.org/" target="_blank">
              <img width={97} height={97} alt="USGBC" src={l3} style={{marginRight: "12px"}}/>
            </a>
            <a href="https://www.clarb.org/" target="_blank">
              <img width={200} height={54} alt="CLARB" src={l4} style={{marginRight: "12px"}}/>
            </a>
          </div>

          <hr style={{margin: 0, marginTop: '2px', borderColor: 'rgb(150, 150, 150)'}}/>

          <h4 className="index-header" style={{fontStyle: 'italic'}}>
            "UNDER A JUNIPER TREE..."
          </h4>

          <div className="juniper">
            <img width={111} height={77} alt="CLARB" src={l5} style={{float: "left", marginRight: "20px", marginBottom: "3px"}}/>
            <p className="index-para">
              And as he lay and slept under a juniper tree, behold, then an angel touched him, and said unto him, Arise and eat.
            </p>
            <p className="index-para" style={{float: "right"}}>
              - 1 Kings 19:5 (KJV) -
            </p>
          </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.tsx